import sumBy from 'lodash/sumBy'
import _filter from 'lodash/filter'
import { OrderPaymentStatusEnum } from '@ztechapps/common.contract'
import { QUALIFYING_PAID_PAYMENT_STATUSES, roundNumber } from '@ztechapps/common.utils'

export const getPaymentStatus = ({
  payments,
  net,
  originalPaymentStatus,
}: { payments?: any[]; net?: number; originalPaymentStatus?: OrderPaymentStatusEnum } = {}) => {
  // "Not Receivable" is a manual, sticky terminal status. Once staff mark an
  // order uncollectible it must survive any later net/gross/payments write that
  // re-triggers this recompute — never let the payment math override it.
  if (originalPaymentStatus === OrderPaymentStatusEnum.notReceivable) return OrderPaymentStatusEnum.notReceivable

  const allPaid = _filter(payments, (item) => QUALIFYING_PAID_PAYMENT_STATUSES.includes(item?.status))

  let totalPaid = sumBy(allPaid, (item) => {
    return item?.gross
  })

  totalPaid = roundNumber(totalPaid, 2)

  if (allPaid?.length === 0 /* || totalPaid === */) return OrderPaymentStatusEnum.unpaid

  if (totalPaid === net) {
    return OrderPaymentStatusEnum.paid
  }

  if (totalPaid < net) {
    return OrderPaymentStatusEnum.partiallyPaid
  }

  if (totalPaid > net) return OrderPaymentStatusEnum.overPaid

  //if (allPaid?.length > 0) return 'Partially Paid'

  return originalPaymentStatus
}
